<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Mi Tarjeta MasterCard
            </b-card-header>

            <b-card-body v-if="!model.viewResult">
                 <div class="row" style="margin-top: 10px">
                    <div class="col-md-12 text-center">
                        <img src="@/assets/tjt_reimprimir.png" />
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>¿Querés denunciar tu tarjeta?</label> 
                    </div>
                </div>  

                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>Atención. Esta operación generará la reimpresión de tu tarjeta debiendo aguardar la entrega de una nueva.</label> 
                    </div>
                </div>   

                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Tipo de Denuncia</label>
                        <KitsCombo
                        v-model="model.complaintTypeID"
                        v-bind:items="tiposDenuncias"
                        propertyName="Name"
                        propertyID="EntityID"
                        nullText=" -- Seleccione un tipo de denuncia -- "
                        :todos="true"
                        ></KitsCombo>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Ingrese una Observación</label> 
                        <base-input v-model="model.observation" placeholder="Observación"></base-input>
                    </div>
                </div>   

                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <b-button class="btn btn-danger" :disabled="!model.isReprint" @click="denunciar">Denunciar</b-button>                        
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <b-button class="btn btn-danger" @click="goBack">Cancelar</b-button>
                    </div>
                </div>
            </b-card-body>
             <contact-help-desk ref="contact-help-desk" titleModal="Reimpresion de Tarjeta"/>
        </b-card> 
    </div>
</template>

<style>
</style>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';
    import PincodeInput from 'vue-pincode-input';
    import KitsCombo from "@/components/KitsCombo";
    import ContactHelpDesk from "@/views/ContactHelpDesk";

    export default {
        components: { 
            "pincode-input": PincodeInput,
            KitsCombo,
             "contact-help-desk": ContactHelpDesk
        },
        data(){
            return{
                model: {   
                    complaintTypeID: 0,
                    observation: '',
                    isReprint: false
                },
                tiposDenuncias: null,
                helpDeskInformation: {
                    Message: "",
                    Show: false,
                    ShowInfo: false,
                    WhatsappUrl: "",
                    PhoneNumber: "",
                    EmailAddress: "",
                    EmailSubject: "",
                    MessageBody: "",
                    ShowUnlockMail: false,
                    Name: "",
                    ShowContactarSoporte: false
                }
            }
        },
        beforeMount: function() {
            let context = this;
            var req = { };
            axiosHelpers.axiosPost("Mastercard/ComplaintsTypes", req, context, function(data) 
            {
                // -- Si es Reimpresion
                if(data.ResponseVM.IsReprint)
                {
                    context.model.isReprint = true;
                    context.tiposDenuncias = data.ResponseVM.Items;
                }
                else
                {   
                    context.helpDeskInformation.Show = true;
                    context.helpDeskInformation.ShowContactarSoporte = true;
                    context.helpDeskInformation.Message = "¡Ups! No podemos solicitar una reimpresion, ya tiene una en curso.";
                    context.helpDeskInformation.EmailAddress = context.$store.getters.EmailAddress;
                    context.helpDeskInformation.EmailSubject = context.$store.getters.EmailSubject;
                    context.helpDeskInformation.MessageBody = context.$store.getters.MessageBody;
                    context.helpDeskInformation.WhatsappUrl = context.$store.getters.UrlWhatsapp;
                    context.helpDeskInformation.PhoneNumber = context.$store.getters.PhoneNumber;
                    context.helpDeskInformation.IsReprint = true;
                    context.$refs["contact-help-desk"].setHelpDeskInformation(context.helpDeskInformation);
                }
            });
        },
        methods: {
            denunciar() {
            let context = this;  
            if (context.model.complaintTypeID == 0) 
            {
                notificationHelpers.showWarning("Advertencia!", "Debe seleccionar un tipo de denuncia.", context);
                return;
            }
            else if (context.model.observation == "") 
            {
                notificationHelpers.showWarning("Advertencia!", "Debe ingresar una observación.", context);
                return;
            }

            this.$validator.validate().then(valid => {
            if (valid) {
            axiosHelpers.axiosPost("Mastercard/ReprintMastercardCard",
                {
                    Observation: context.model.observation,
                    ComplaintTypeID: context.model.complaintTypeID
                },
                this, function(data) 
                {
                    if (data.ResponseVM.Result)
                    {
                        context.$router.push({ name: "MyMastercardWallet", params: { IsReprint: true }});   
                    }
                    else
                    {
                        notificationHelpers.showError("Error!", "Ocurrio un error al solicitar la reimpresión.", context);
                    }
                }
            );
        } 
        else
        {
            notificationHelpers.showWarning("Advertencia!", "Verifique todos los campos", context);
        }
        });
        },
        goBack()
        {
            let context = this;
            if(this.model.isReprint) this.$router.push({ name: "MyMastercardWallet", params: { IsReprint: true }}); 
            else this.$router.push({ name: "MyMastercardWallet"});
        },
        cancelar()
        {
            let context = this;
            if(this.model.isReprint) this.$router.push({ name: "MyMastercardWallet", params: { IsReprint: true }}); 
            else this.$router.push({ name: "MyMastercardWallet"});
        }
    }
}
</script>